
export function cover3D(selectedTemplate, small = false) {

  return (
    <div
      className={`relative  ${small ? 'md:min-h-[110px] md:h-[110px]  md:w-[80px] min-h-[98px] h-[110px]  w-[80px]' : 'md:min-h-[190px]  md:w-[135px] h-[150px] w-[95px]'}`}
      style={{

        "--bookWidth": small ? "80px" : "135px",
        "--bookHeight": small ? "100px" : "190px",
        "--spineWidth": small ? "14px" : "16px",
        perspective: "1000px",

        backgroundColor: 'transparent'
      }}
    >
      <div
        className="relative transform-style-3d"
        style={{
          transform: "rotateY(-30deg)",
          transformOrigin: "center center",
          transformStyle: ' preserve-3d',
          width: "100%",
          height: "100%",
          position: "relative",
          zIndex: "2",
        }}
      >
        {/* Front page */}
        <img
          className=""
          style={{
            transform: "translateZ(0)",
            boxShadow: "0 0 15px #999",
            width: "100%",
            height: "100%",


          }}
          src={selectedTemplate.front}
          alt="Book Cover"
        />

        {/* Pages */}
        <div
          className="absolute z-1 bg-white"
          style={{
            width: "var(--spineWidth)",
            height: "100%",
            transformOrigin: "left",
            transform: "rotateY(60deg)",
            borderTop: "1px solid rgba(0, 0, 0, 0.08)",
            borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
            top: '0',
            right: small ? '-12px' : '-16px',
            boxShadow: "8px 0px 6px #eaeaea",
          }}
        >
          <div
            className="absolute w-full h-full"
            style={{
              background: "linear-gradient(-90deg, transparent 60%, rgba(0, 0, 0, 0.2))",
            }}
          ></div>
        </div>

        {/* Back */}
        <div
          className="absolute z-4 mt-1"
          style={{
            width: "5px",
            transform: "",
            transformOrigin: "",
            right: '-16px',
            top: '-2px',
            height: 'calc(100% - 4px)',
            opacity: '0.7'
          }}
        >
        </div>


      </div>
    </div>
  )
}
function BookPreview({ selectedTemplate, authorName, selectedTopic, selectedSubTopic, small = false }) {

  const cover3DTemplate = cover3D(selectedTemplate, small);

  return (
    <div>
      <div className="flex items-center md:justify-center  gap-6 flex-1  ">

        {selectedTemplate?.front ? (

          <>
            {cover3DTemplate}
          </>


        ) : (
          <p className="text-gray-500 mt-4">No cover selected</p>
        )}
        <div
          className={`flex flex-1 md:flex-none flex-col  justify-center min-h-[210px] ${small ? 'md:min-h-[140px]' : 'md:min-h-[190px]'} font-inter  w-2/3 md:w-fit`}

        >
          <div className="w-fit">
            {/* Title - always visible */}
            <div className={`text-[#2B2B2B] ${small ? 'text-base md:w-fit' : 'text-[20px] md:text-[24px] leading-[26px]'} font-semibold`}>
              {selectedTopic}
            </div>

            {/* Subtitle */}
            {/* Show only when NOT small, or always on desktop */}
            {(!small || small) && (
              <div
                className={`${small ? 'hidden md:block' : ''
                  } text-[#2B2B2B]/75 text-[15px] md:text-base mt-2`}
              >
                {selectedSubTopic}
              </div>
            )}

            {/* Author */}
            <div
              className={`${small
                  ? 'text-[#2B2B2B]/75 text-base mt-2 md:text-[#2B2B2B] md:font-medium md:mt-2'
                  : 'text-[#2B2B2B] font-medium mt-1.5 md:mt-2'
                } md:w-fit`}
            >
              by <span>{authorName}</span>
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}

export default BookPreview
